import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { FlexColumnDiv } from "./common.styles";
export const RequestDetailsContainer = styled(FlexColumnDiv) `
    padding: 0 32px 16px 32px;
    gap: 16px;
    align-items: flex-start;
    align-self: stretch;
    flex: 1;
`;
export const RequestDetailsTitle = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.MOBILE_TITLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: 36px;
    align-self: stretch;
`;
export const ReasonForRequestSection = styled(FlexColumnDiv) `
    gap: 4px;
    padding: 12px;
    border-radius: 12px;
    background-color: ${colors.blue_5};
    align-self: stretch;
`;
export const ReasonForRequestText = styled.div `
    color: ${colors.navy_main};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    white-space: pre-wrap;
`;
export const DetailsSection = styled(FlexColumnDiv) `
    gap: 12px;
    padding: 12px;
    border-radius: 12px;
    border: 1px solid ${colors.blue_10};
    align-self: stretch;
`;
export const DetailItem = styled(FlexColumnDiv) `
    gap: 4px;
    align-items: flex-start;
`;
export const DetailLabel = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
`;
export const DetailValue = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    white-space: pre-wrap;
`;
export const FAQsTitle = styled.div `
    color: ${colors.black_light};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    line-height: normal;
    letter-spacing: 0.15px;
    align-self: stretch;
`;
export const FAQsContainer = styled(FlexColumnDiv) `
    gap: 12px;
    align-self: stretch;
`;
